<div class="header d-none d-md-block">
  <h1 class="d-inline-block v-align-middle">{{title | translate}}</h1>
  @if (allowNew) {
    <button class="btn btn-outlined btn-list-header" (click)="onCreateItem()">
      <img src="assets/icons/plus-darker.svg" alt="create" />{{'CREATE_BTN' | translate}}
    </button>
  }
  @if (showExcelExportButton && excelReady) {
    <app-excel-list
      class="btn-list-header"
      [columnDefinition]="excelColumnDefinition"
      [selectedListViewColumns]="selectedColumns"
      [excelContext]="excelContext"
      [filter]="filterState"
      [fileName]="excelFileName"
      [selectedIds]="getSelectedIds"
      [deSelectedIds]="getDeselectedIds"
      [affectedItemsCount]="getAffectedItemsCount"
      [allSelected]="getAllSelected"
      [totalResults]="totalResults"
    ></app-excel-list>
  }
</div>

<div class="header d-flex d-md-none align-items-center excel-header-wrap">
  <h1 class="w-100">{{title | translate}}</h1>
  @if (allowNew) {
    <button class="btn btn-outlined" (click)="onCreateItem()">
      <img src="assets/icons/plus-darker.svg" alt="create" />{{'CREATE_BTN' | translate}}
    </button>
  }
  @if (showExcelExportButton && excelReady) {
    <app-excel-list
      [columnDefinition]="excelColumnDefinition"
      [selectedListViewColumns]="selectedColumns"
      [excelContext]="excelContext"
      [filter]="filterState"
      [fileName]="excelFileName"
      [selectedIds]="getSelectedIds"
      [deSelectedIds]="getDeselectedIds"
      [affectedItemsCount]="getAffectedItemsCount"
      [allSelected]="getAllSelected"
      [totalResults]="totalResults"
      [isMobile]="true"
    ></app-excel-list>
  }
</div>

@if (helpText) {
  <app-information-block [text]="helpText | translate"></app-information-block>
}

<app-filter [filters]="filterDefinition" (change)="onFilterChange($event)" [defaultFilters]="defaultFilters"></app-filter>

@if (itemsSource) {
  <app-paged-list-view
    [columnDefinition]="columnDefinition"
    [contextMenuDefinition]="contextMenuDefinition"
    [menuDefinition]="menuDefinition"
    [itemsSource]="itemsSource"
    [totalCount]="totalResults"
    [preferencesKey]="preferencesKey"
    (onPageChange)="pagingChanged($event)"
    (onSortChange)="sortChanged($event)"
    (onColumnChange)="onColumnChange($event)"
    (onSelectedIdsChange)="onSelectedIdsChange($event)"
    (onDeselectedIdsChange)="onDeselectedIdsChange($event)"
    (onAffectedItemsCountChange)="onAffectedItemsCountChange($event)"
    (onAllSelectedChange)="onAllSelectedChange($event)"
    (rowClick)="onRowClicked($event)"
    [isToolbarSticky]="true"
    >
  </app-paged-list-view>
}
